import { IAtClickableProps } from '@/components/atoms/at-clickable/at-clickable';
import { THeaderSupportedElements } from '@/components/atoms/at-header/at-header.types';
import { IDefaultCsProps, TSpacingProp } from '@/lib/contentstack-sdk/types';
import { IAtLinkCMSProps } from '@/lib/contentstack-sdk/utils/parseHelpers';

export interface IMlHeaderCMSProps extends IDefaultCsProps {
  head: string;
  head_element?: { select?: THeaderSupportedElements };
  body?: string;
  alignment?: 'Left' | 'Center' | 'Right';
  text_order?: 'Vertical' | 'Horizontal';
  cta?: IAtLinkCMSProps[] | undefined;
  size?: 'Small' | 'Large';
  top_spacing?: TSpacingProp;
  bottom_spacing?: TSpacingProp;
  _content_type_uid: 'or-small-header';
}

export enum EMlHeaderSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum EAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum EOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export interface IMlHeaderProps {
  head: string;
  headElement?: THeaderSupportedElements;
  body?: string;
  alignment?: EAlignment;
  order?: EOrientation;
  ctaProps?: IAtClickableProps;
  className?: string;
  size?: EMlHeaderSize;
}
